import { render, staticRenderFns } from "./CompanyAirportDiscountForm.vue?vue&type=template&id=0f8e5596&"
import script from "./CompanyAirportDiscountForm.vue?vue&type=script&lang=js&"
export * from "./CompanyAirportDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports